import React, { Component } from 'react';
import config from 'react-global-configuration';
import CalendarDayTeam from './CalendarDayTeam';

class CalendarDay extends Component {


  render() {
    return (
<tr>
  {this.props.semana.map(function(dia, linha) {
    if (dia.day) {
      return (
        <td>
          <p className="text-center calendario-dia"><strong>{dia.day}</strong></p>
          <div className="calendario-cont">
            <CalendarDayTeam training_schedules={dia.training_schedules} daily_schedules={dia.daily_schedules} mission_schedules={dia.mission_schedules} base_schedules={dia.base_schedules} team_schedules={dia.team_schedules} />
          </div>
        </td>
      );
    } else {
      return (
        <td></td>
      );      
    }
  })}
</tr>             
    );
  }
}

export default CalendarDay;



// WEBPACK FOOTER //
// ./src/Components/Calendar/Elements/CalendarDay.js